import * as yup from 'yup';
import { treasuryTestTopUpFormFields } from '../../fields/formFields/treasuryTestTopUp';
import { amountSchema } from '../common/amountSchema';

export const treasuryTestTopUpSchema = yup.object({
  [treasuryTestTopUpFormFields.amount]: amountSchema,
  [treasuryTestTopUpFormFields.processNow]: yup.boolean(),
});
